// Recovered compiled webpack factory 79152. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n;
  r.d(t, { _: () => l });
  var a = r(21010),
    o = r(51217),
    i = r(73314),
    s = r(38599);
  function l(e) {
    let t = "history";
    ((0, a.s5)(t, e), (0, a.AS)(t, u));
  }
  function u() {
    function e(e) {
      return function (...t) {
        let r = t.length > 2 ? t[2] : void 0;
        if (r) {
          let o = n,
            i = (function (e) {
              try {
                return new URL(e, s.j.location.origin).toString();
              } catch {
                return e;
              }
            })(String(r));
          if (((n = i), o === i)) return e.apply(this, t);
          (0, a.aj)("history", { from: o, to: i });
        }
        return e.apply(this, t);
      };
    }
    (s.j.addEventListener("popstate", () => {
      let e = s.j.location.href,
        t = n;
      ((n = e), t !== e && (0, a.aj)("history", { from: t, to: e }));
    }),
      (0, o.NJ)() &&
        ((0, i.GS)(s.j.history, "pushState", e), (0, i.GS)(s.j.history, "replaceState", e)));
  }
}
